import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { BreakPointToken } from '../../hooks/useMediaQuery';
import { StyledScrollbars } from '../../lib/utils/mixins';

const {
	color: colours,
	spacing: {
		size_2px: { height: size_2 },
		size_4px: { height: size_4 },
		size_8px: { height: size_8 },
		size_16px: { height: size_16 },
		size_20px: { height: size_20 },
		size_40px: { height: size_40 },
		size_112px: { height: size_112 },
		size_160px: { height: size_160 }
	}
} = tokens;

export const CounterPanel = styled.div<{ noMargin?: boolean }>`
	display: flex;
	justify-content: space-between;
	padding: 0;
	margin-block-start: ${({ noMargin }) => (noMargin ? 0 : size_16)}px;
`;

export const CounterText = styled.div`
	flex: 1;
	@media (min-width: ${BreakPointToken.MdMin}px) {
		min-width: ${size_40 + size_160}px;
	}
	& span {
		color: ${colours.light.text_secondary};
	}
`;

export const Alert = styled.span`
	display: flex;
	align-items: flex-start;
	margin-block-end: ${size_16}px;
	color: ${colours.light.text_error};
	@media (min-width: ${BreakPointToken.MdMin}px) {
		max-width: ${size_112 + size_160}px;
	}

	& span {
		margin-inline-end: ${size_4}px;
	}
`;

export const CounterButton = styled.div`
	margin-block-start: ${size_20}px;
`;

export const RoomCompositionPanel = styled.div`
	padding: 0 ${size_2}px ${size_8}px ${size_2}px;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		overflow-y: auto;
		max-height: ${size_40 + size_160 + size_40 + size_160}px;
		${StyledScrollbars};
	}
`;

export const Room = styled.div<{ idx: number }>`
	${({ idx }) =>
		idx > 0 &&
		`
	margin-block-start: ${size_20}px;
	padding-block-start: ${size_20}px;
	border-top: 1px solid ${colours.light.border_decorative};
	`}
`;

export const RoomHeading = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ChildPanel = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	& > div {
		flex: 0 0 calc(50% - ${size_8}px);
		margin-block-start: ${size_16}px;
	}

	& select {
		outline-offset: 0 !important;
	}
`;

export const RemoveRoom = styled.button`
	display: inline;
	outline: none;
	border: none;
	padding: 0;
	background: transparent;
	text-decoration: underline;
	color: ${colours.light.background_red};
	cursor: pointer;
	transition: color 0.3s ease-in-out;

	&:hover {
		color: ${colours.light.brandprimary_70};
	}

	&:focus {
		outline: 2px solid ${colours.light.blue_40};
		border-radius: ${size_4}px;
	}
`;

export const RemoveRoomText = styled.span`
	margin-inline-start: ${size_8}px;
`;
